/// \file mainLayout.tsx
///
/// \par Copyright Notice:
/// Copyright (c) 2023 by Oshkosh Corporation.
/// All Rights Reserved.
///
/// \par
/// The information contained herein is confidential and proprietary property
/// of Oshkosh Corporation, and may be privileged.  The dissemination,
/// distribution, use, copying, transfer, or disclosure of such information is
/// strictly prohibited except by express written agreement with Oshkosh
/// Corporation, or with one of its subsidiaries.

import { Outlet } from "react-router-dom";
import Breadcrumbs from "../breadcrumbs";

import Navbar from "../navbar";

function Layout() {
    
  return (
    <div>
      <Navbar/>
      <Breadcrumbs/>
      <main>
        <Outlet/>
      </main>
    </div>
  );
}

export default Layout;